import {
  QuoteUnderwritingTaskPostRequestBody,
  QuoteUnderwritingTaskPostResponse,
  QuoteUnderwritingTaskSearchResponse,
} from '@lio/api-types';
import { UnderwritingIssue } from '@models/underwritingIssue';
import { queryKeys as underwritingReferralQueryKeys } from '@services/underwritingReferral';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useNewTask = (quoteId: string | undefined) => {
  const client = useClient();
  const queryClient = useQueryClient();

  const mutationFn = ({
    underwritingRuleId,
    underwritingRuleDetail,
    underwriterDisposition,
    underwriterComment,
  }: QuoteUnderwritingTaskPostRequestBody) =>
    client
      .post(`quote/${quoteId}/underwriting-task`, {
        json: {
          underwritingRuleId,
          underwritingRuleDetail,
          underwriterDisposition,
          underwriterComment,
        },
      })
      .json<QuoteUnderwritingTaskPostResponse>();

  const result = useMutation({
    mutationFn,
    onSuccess: async (data) => {
      const quoteUnderwritingTaskToAdd: UnderwritingIssue = {
        ...data,
        underwritingRule: {
          id: '',
          underwritingLabel: '',
          description: '',
          underwritingDescription: '',
        },
      };
      queryClient.setQueryData<QuoteUnderwritingTaskSearchResponse>(['underwritingTasks'], (previousTasks) =>
        previousTasks
          ? {
              ...previousTasks,
              items: [...previousTasks.items, quoteUnderwritingTaskToAdd],
            }
          : previousTasks,
      );
      queryClient.invalidateQueries({ queryKey: ['quotes'] });
      queryClient.invalidateQueries({ queryKey: ['underwritingTasks'] });
      queryClient.invalidateQueries({ queryKey: ['quote', { quoteId }] });
      queryClient.invalidateQueries({ queryKey: [underwritingReferralQueryKeys.underwritingActivity] });
    },
  });
  return { ...result, createNewTaskAsync: result.mutateAsync };
};
